import Media from 'react-media';
import { Text, useTheme } from '@simplywallst/ui-core';
import { Container } from './styled';
import {
  Logo,
  Content,
  SectionLogo,
  SectionText,
  HeadingText,
} from '../SplashPanelRegister/styled';

export const SplashPanelSignIn = () => {
  const theme = useTheme();
  return (
    <Container>
      <Content>
        <SectionLogo>
          <Logo />
        </SectionLogo>
        <SectionText>
          <HeadingText as={'h1'}>
            Continue to Simply Wall St stock analysis tool
          </HeadingText>
          <Media query={{ minWidth: theme.mdMaxRaw }}>
            <Text color={'darkerGray'}>
              Packed with data-driven analysis and intelligent tools to enhance
              your investment journey.
            </Text>
          </Media>
        </SectionText>
      </Content>
    </Container>
  );
};
